













































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { Utils } from "@/service/util";
import Number from "@/shared/filters/Number";
import { KbnSkn } from "@/model/KbnSkn";
import requestService from "@/service/requestService";
import PaymentService from "@/service/paymentService";
import { CustomerSave } from "@/model/CustomerSave";
import { Getter, Action } from "vuex-class";
import { INSPECT_TYPE } from "@/model/InspectType";
import { CouponData } from "@/model/Coupon";
import { UserService } from "@/service/UserService";
import { SocketControllers } from "@/service/SocketControllers";
import { SeibiItem } from "@/model/InspectionSeibi";
import { SeibiItemSave } from "@/model/CustomerSave";
import TopBarTitle from '@/components/common/TopBarTitle.vue';
import { MESSAGE } from "@/model/Message";
import NextageFooter from "@/components/nextageFooter.vue";

@Component({
  filters: {
    Number
  },
  components: {
    ConfirmDialog,
    TopBarTitle
    , NextageFooter
  }
})
export default class PaymentDetail extends Vue {
  showAside: boolean = true;
  $refs!: {
  //  confirmDialog: ConfirmDialog;
    cancelDialog: ConfirmDialog;
  };

  reqService: requestService;
  pmtService: PaymentService;
  sktControll: SocketControllers;
  userService: UserService;
  dataForSave: CustomerSave;
  isUserMode: boolean = false;

  updating: boolean = false;
  loadingText: string = MESSAGE.Loading;

  totalBaseZn: number = 0;
  totalBaseZk: number = 0;
  totalBCalcZk: number = 0;

  isExitConnectSocket: boolean = false;

  public utils: Utils = new Utils();

  @Prop() onUserConfirmUpdating: boolean;

  @Getter("getSeibiData", { namespace: "InspectSeibi" })
  seibi: any;
  @Getter("getManualSeibiData", { namespace: "InspectSeibi" })
  seibiManual: any;

  @Getter("isConfirmLegal56", { namespace: "InspectSeibi" })
  isConfirmLegal56: number;
  @Getter("isConfirmRecommend", { namespace: "InspectSeibi" })
  isConfirmRecommend: number;

  @Getter("listInspectByType", { namespace: "InspectSeibi" })
  listInspect!: (inspectType: number) => SeibiItem[];

  // @Getter("dataForSavePayment", { namespace: "Shohiyou" })
  // shakenShohiyou: ShakenShohiyou;
  @Getter("isConfirm", { namespace: "Shohiyou" })
  isConfirmShohiyou: number;

  @Getter("currentState", { namespace: "Coupon" })
  couponData: CouponData;

  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;
  @Getter("uketsukeCd", { namespace: "ReservationDetail" })
  uketsukeCd: string;
  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;

  @Getter("loadData", { namespace: "Payment" })
  loadData: number;
  @Getter("isConfirmNex", { namespace: "Payment" })
  isConfirmPaymentNex: number;

  @Action("confirm", { namespace: "Payment" })
  confirmPayment: any;

  @Getter("stateId", { namespace: "SubHeader" })
  stateId: number;

  @Getter("isConfirm", { namespace: "Option" })
  isConfirmOption: number;

  /** 2023-10-19 invoice [START] */
  @Getter("isExcludingTax", { namespace: "FunctionSetting" })
  isExcludingTax: any;

  @Getter("taxLabel", { namespace: "FunctionSetting" })
  taxLabel: string;
  /** 2023-10-19 invoice [END] */

  @Getter("isNextageCustom", { namespace: "FunctionSetting" })
  isNextageCustom: any;

  loading: boolean = false;
  /** 2022-11-17 sh #8121(BQR986) reload after change shaken-shurui. [END] */

  /*
   * 初期化関数
   * ( createdやmountedで1回だけ実行される必要があるが
   *   特定のパラメータが足りない時は実行順序を前後させる必要がある処理 )
   */
  @Watch("uketsukeCd")
  connectSocket() {
    // 必要な値が未セット、または初期化済みなら何もしない
    if (!this.uketsukeCd || this.isExitConnectSocket) { return; }
    this.isExitConnectSocket = true;

    this.sktControll = new SocketControllers(this);
    if (this.isUserMode) {
      this.sktControll.socketEntry("updateCourseSubscription",this.onUpdateTotal); // catchSocket:08車検コース変更による再描画指示
    }
    this.sktControll.connectSocket();
  }

  created() {
    this.reqService = new requestService();
    this.pmtService = new PaymentService();
    this.userService = new UserService();

    if (!this.loadData) {
      this.userService.getAllData();
    }
    if (this.$route.meta == "user") { this.isUserMode = true; }
    this.connectSocket();
  }

  mounted() {
    this.$emit("onActiveSideTab", "requiredetail");
  }

  onConfirm() {
    if (this.isConfirmPaymentNex == 0) {

      const param = {
        sknUketsukeExtendsId: this.uketsukeExtendsId,
        isConfirmInspect: this.isConfirmLegal56,
        isConfirmRecommend: this.isConfirmRecommend,
        isConfirmPayment: 2
      };
      this.reqService.saveIsConfirm(param).then(() => {
        this.confirmPayment(2);// 自分自身の未/確を有効にする(storeのみ。)
        // 最終確認ではない為、確認モーダルはスキップして次に進む。onSubmitConfirm()相当の動作
        this.$router.push({ name: "userlegal56Nex2" });
      }, (error: any) => {
        this.$notify.info({
          title: "エラー",
          message: MESSAGE.SystemError
        });
      });
    } else {
      // 最終確認ではない為、確認モーダルはスキップして次に進む。onSubmitConfirm()相当の動作
      this.$router.push({ name: "userlegal56Nex2" });
    }
  }

  get sum() { // 税込みの合算
    this.totalCalc();
    if ( this.isExcludingTax ) {
      return this.totalBCalcZk;
    } else {
      return this.totalBaseZk;
    }
  }

  totalCalc() {
    const promise2 = this.pmtService.setTotalCalcNex();
    Promise.all([promise2]).then(() => {
      const state = this.pmtService.getTotalCalcNex();
      this.totalBaseZn = state.totalSumZn;
      this.totalBaseZk = state.totalSumZk;
      this.totalBCalcZk = state.totalCalcZk;
    });
  }

  get disableConfirm() {
    let listRecommend = this.listInspect(INSPECT_TYPE.RECOMMEND);
    return (
      this.isConfirmShohiyou == 0 ||
      // this.isConfirmOption == 0 ||
      this.couponData.isConfirm == 0 ||
      ( this.isConfirmLegal56 == 0 || this.isConfirmLegal56 == 3 )
      // (this.isConfirmRecommend == 0 && listRecommend.length > 0)
    );
  }

  gotoWorkOrder() {
    this.$router.push({ name: "userworkorder" });
  }

  // onCancel() {
  //  if (this.$refs.cancelDialog) {
  //    this.$refs.cancelDialog.onOpen();
  //  }
  // }

  cancel() {
    const data = {
      sknUketsukeExtendsId: this.uketsukeExtendsId,
      uketsukeCd: this.uketsukeCd,
      yoyakuNo: this.yoyakuNo
    };
    this.reqService.saveCancel(data).then((res: any) => { // sendSocket:32車検中止
      if (this.isUserMode) {
        this.$router.push({ name: "reservationNumber" });
      } else {
        this.$router.push({ name: "reservation" });
      }
    });
  }

  /** 2022-11-17 sh #8121(BQR986) reload after change shaken-shurui. [START] */
  onUpdateTotal() {
    this.$set(this, "updating", true);
    setTimeout(() => {
      this.$set(this, "updating", false);
      this.totalCalc(); // 金額更新
    }, 2000);
  }

  /** 2022-11-17 sh #8121(BQR986) reload after change shaken-shurui. [END] */
}
